/*!
 * blog.js
 */
require('bootstrap/dist/css/bootstrap.min.css');
require('css/v2dt.css');
require('font-awesome/css/font-awesome.min.css');
require('bootstrap/dist/js/bootstrap');